// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./components/brush_wave.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./components/brush_wave_red.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lexend+Deca:wght@400;500;600;700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pdf-container {
    width: 210mm;
    /* height: 297mm; */
    margin: 0;

    
}

.download-button {
    margin-top: 20px;
    padding: 10px 20px;
    font-size: 16px;
    cursor: pointer;
}
.first-page {
    background-color: red;
    /* height: 297mm; */
    /* padding: 20mm; */
}

@media print {
  * {
    page-break-inside: avoid !important;
    break-inside: avoid !important;
  }
}

.heading2 {
  display: inline-block;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center;
  background-size: 100% 100%; /* Changed from contain to stretch to full size */
  padding: 1em 1em;
  text-transform: uppercase;
  font-weight: 100;
  font-family: 'Lexend Deca', sans-serif;
  font-size: 18px;
  min-width: 200px; /* Add minimum width */
  min-height: 60px; /* Add minimum height */
  text-align: center; /* Center the text */
  display: flex; /* Use flex for better centering */
  align-items: center; /* Vertical center */
  justify-content: center; /* Horizontal center */
}

.heading1 {
  display: inline-block;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center;
  background-size: 100% 100%; /* Changed from contain to stretch to full size */
  padding: 1em 1em;
  text-transform: uppercase;
  font-weight: 100;
  font-family: 'Lexend Deca', sans-serif;
  font-size: 40px;
  min-width: 200px; /* Add minimum width */
  min-height: 60px; /* Add minimum height */
  text-align: center; /* Center the text */
  display: flex; /* Use flex for better centering */
  align-items: center; /* Vertical center */
  justify-content: center; /* Horizontal center */
}

/* .heading1 {
  position: relative;
  display: flex; 
  align-items: center; 
  justify-content: center; 
  font-weight: 100;
  font-size: 40px;
  font-family: 'Lexend Deca', sans-serif;
  padding: 0.55em 0.55em;
  color: black;
  z-index: 1;
  min-width: 300px; 
  min-height: 80px; 
  text-align: center; 
  text-transform: uppercase;
}

.heading1::before {
  content: '';
  position: absolute;
  inset: 0;
  background-image: url('./components/brush_wave_red.svg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
  z-index: -1;
  text-transform: uppercase;
}
 */




 `, "",{"version":3,"sources":["webpack://./src/views/admin/default/Report/index.css"],"names":[],"mappings":"AAIA;IACI,YAAY;IACZ,mBAAmB;IACnB,SAAS;;;AAGb;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;AACA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;EACE;IACE,mCAAmC;IACnC,8BAA8B;EAChC;AACF;;AAEA;EACE,qBAAqB;EACrB,oEAA+D;EAC/D,0BAA0B,EAAE,iDAAiD;EAC7E,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,sCAAsC;EACtC,eAAe;EACf,gBAAgB,EAAE,sBAAsB;EACxC,gBAAgB,EAAE,uBAAuB;EACzC,kBAAkB,EAAE,oBAAoB;EACxC,aAAa,EAAE,kCAAkC;EACjD,mBAAmB,EAAE,oBAAoB;EACzC,uBAAuB,EAAE,sBAAsB;AACjD;;AAEA;EACE,qBAAqB;EACrB,oEAAmE;EACnE,0BAA0B,EAAE,iDAAiD;EAC7E,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,sCAAsC;EACtC,eAAe;EACf,gBAAgB,EAAE,sBAAsB;EACxC,gBAAgB,EAAE,uBAAuB;EACzC,kBAAkB,EAAE,oBAAoB;EACxC,aAAa,EAAE,kCAAkC;EACjD,mBAAmB,EAAE,oBAAoB;EACzC,uBAAuB,EAAE,sBAAsB;AACjD;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA4BE","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Lexend+Deca:wght@400;500;600;700&display=swap');\n\n\n\n.pdf-container {\n    width: 210mm;\n    /* height: 297mm; */\n    margin: 0;\n\n    \n}\n\n.download-button {\n    margin-top: 20px;\n    padding: 10px 20px;\n    font-size: 16px;\n    cursor: pointer;\n}\n.first-page {\n    background-color: red;\n    /* height: 297mm; */\n    /* padding: 20mm; */\n}\n\n@media print {\n  * {\n    page-break-inside: avoid !important;\n    break-inside: avoid !important;\n  }\n}\n\n.heading2 {\n  display: inline-block;\n  background: url('./components/brush_wave.svg') no-repeat center;\n  background-size: 100% 100%; /* Changed from contain to stretch to full size */\n  padding: 1em 1em;\n  text-transform: uppercase;\n  font-weight: 100;\n  font-family: 'Lexend Deca', sans-serif;\n  font-size: 18px;\n  min-width: 200px; /* Add minimum width */\n  min-height: 60px; /* Add minimum height */\n  text-align: center; /* Center the text */\n  display: flex; /* Use flex for better centering */\n  align-items: center; /* Vertical center */\n  justify-content: center; /* Horizontal center */\n}\n\n.heading1 {\n  display: inline-block;\n  background: url('./components/brush_wave_red.svg') no-repeat center;\n  background-size: 100% 100%; /* Changed from contain to stretch to full size */\n  padding: 1em 1em;\n  text-transform: uppercase;\n  font-weight: 100;\n  font-family: 'Lexend Deca', sans-serif;\n  font-size: 40px;\n  min-width: 200px; /* Add minimum width */\n  min-height: 60px; /* Add minimum height */\n  text-align: center; /* Center the text */\n  display: flex; /* Use flex for better centering */\n  align-items: center; /* Vertical center */\n  justify-content: center; /* Horizontal center */\n}\n\n/* .heading1 {\n  position: relative;\n  display: flex; \n  align-items: center; \n  justify-content: center; \n  font-weight: 100;\n  font-size: 40px;\n  font-family: 'Lexend Deca', sans-serif;\n  padding: 0.55em 0.55em;\n  color: black;\n  z-index: 1;\n  min-width: 300px; \n  min-height: 80px; \n  text-align: center; \n  text-transform: uppercase;\n}\n\n.heading1::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background-image: url('./components/brush_wave_red.svg');\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100% 100%;\n  z-index: -1;\n  text-transform: uppercase;\n}\n */\n\n\n\n\n "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
